import { render, staticRenderFns } from "./IAOut.vue?vue&type=template&id=5f1432aa&scoped=true"
import script from "./IAOut.vue?vue&type=script&lang=js"
export * from "./IAOut.vue?vue&type=script&lang=js"
import style0 from "./IAOut.vue?vue&type=style&index=0&id=5f1432aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f1432aa",
  null
  
)

export default component.exports